import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed01e62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-7ed01e62><span class=\"bold\" data-v-7ed01e62>注意：</span> 请勿在中国等非覆盖国家禁止插卡到目的地插卡之后，重启手机。<br data-v-7ed01e62> 然后开启<span class=\"link\" data-v-7ed01e62>【蜂窝数据】</span>和<span class=\"link\" data-v-7ed01e62>【数据漫游】</span>，稍等几分钟即可上网。<br data-v-7ed01e62> 注意双卡手机需放在卡1，且卡2不要插卡。<br data-v-7ed01e62><span class=\"bold\" data-v-7ed01e62>极少部分手机如果不能上网，请按照以下设置</span><span class=\"bold\" data-v-7ed01e62>➢ iPhone手机</span> 1、设置 &gt;蜂窝网络 &gt;开启【移动/蜂窝数据)<br data-v-7ed01e62> 2、设置&gt;蜂窝网络&gt;点进去SIM卡，开启【数据漫游<br data-v-7ed01e62> 如无法上网:<br data-v-7ed01e62> ①请检查是否有描述档(设置-通用-APN与设备管理删除所有描述档文件)，或者尝试重启手机。<br data-v-7ed01e62> ②双卡手机建议只插我们的卡，能上网之后再插自己国内卡。如果不会操作，建议不要插自己国内卡，避免产生费用。<br data-v-7ed01e62><span class=\"bold\" data-v-7ed01e62>➢ Android手机</span> 设置&gt;无线和网络&gt;移动网络&gt;开启【数据漫游】、开启4G(或LTE)<br data-v-7ed01e62> 如无法上网:<br data-v-7ed01e62> ①请检查APN是否正确，必须全英文填写，设置完成之后选中。<br data-v-7ed01e62> ②双卡手机建议只插我们的卡，能上网之后再插自己国内卡。如果不会操作，建议不要插自己国内卡，避免产生费用。<br data-v-7ed01e62></div>", 1)

import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { NavBar } from "vant";

export default /*#__PURE__*/_defineComponent({
  name: 'instructions',
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "使用说明",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _hoisted_2
  ]))
}
}

})